import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';
import './Styles.css';
import { useAgentDetails } from '../utils/useAgentDetails';
import { FaBellSlash } from 'react-icons/fa';

import { handleTokenAndPostRequest } from '../utils/utils';

function Unsubscribe() {
  const [noTokenMessage, setNoTokenMessage] = useState('');
  const [isUnsubscribing, setIsUnsubscribing] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const param_token = params.get('token');
  const campaign = params.get('campaign');

  const isPropertyCampaign = campaign === 'property_update' || campaign === 'property_report';
  const isMarketCampaign = campaign === 'market_update';

  const { agent_slug, agentDetails, setAgentDetails, branding } = useAgentDetails();

  const { accentColor, buttonTextColor, isLight, iconColor, iconBgColor } = branding || {};

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!param_token) {
      setNoTokenMessage("Sorry, we can't unsubscribe you as there is no email attached to this request");
      return;
    }
    setIsUnsubscribing(true);
    try {
      const response = await handleTokenAndPostRequest(
        `${window.api_host}/unsubscribe`,
        {
          suburb_market_updates: isMarketCampaign,
          property_updates: isPropertyCampaign,
          agency_id: agentDetails.agency_id,
          agent_id: agentDetails.agent_id,
          agent_slug: agent_slug,
        },
        {
          'Content-Type': 'application/json',
        }
      );

      setIsUnsubscribing(false);
      if (response.data.success) {
        setSuccessMessage("You have been successfully unsubscribed.");
        setNoTokenMessage('');
      } else {
        setNoTokenMessage('There was an error processing your request.');
      }
    } catch (error) {
      console.error('Error:', error);
      setNoTokenMessage('Failed to connect. Please try again later.');
      setIsUnsubscribing(false);
    }
  };

  if (!agentDetails) {
    return (
      <div style={{ 
        position: 'absolute', 
        top: '50%', 
        left: '50%', 
        transform: 'translate(-50%, -50%)' 
        }}>
        <Spinner animation="border" />
        </div>
    );
  }
  
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f3f4f6' }}>

      <Container style={{ maxWidth: 560, position: 'relative' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 8 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 14,
              backgroundColor: `${iconBgColor}14`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <FaBellSlash size={22} style={{ color: iconColor }} />
            </div>
            <h1 style={{
              fontSize: '1.6rem', fontWeight: 700, color: '#111',
              margin: 0, letterSpacing: '-0.02em',
            }}>
              Unsubscribe
            </h1>
          </div>
          <p style={{
            fontSize: '0.92rem', color: '#6b7280', marginBottom: 0,
            lineHeight: 1.6, maxWidth: 420, margin: '0 auto',
          }}>
            Click below to confirm you wish to unsubscribe from {isPropertyCampaign ? 'Property Updates' : 'Suburb Market Updates'}.
          </p>
        </div>

        <div style={{
          backgroundColor: '#fff',
          borderRadius: 16,
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
          padding: '28px 28px',
        }}>
          <Form onSubmit={handleSubmit}>
            <Button
              type="submit"
              disabled={isUnsubscribing}
              style={{
                width: '100%',
                backgroundColor: accentColor,
                borderColor: isLight ? '#222' : accentColor,
                color: buttonTextColor,
                borderRadius: 12,
                padding: '14px 0',
                fontWeight: 600,
                fontSize: '0.95rem',
                boxShadow: `0 4px 16px ${accentColor}30`,
                transition: 'opacity 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}
            >
              {isUnsubscribing ? <Spinner animation="border" size="sm" /> : 'Unsubscribe'}
            </Button>
            {successMessage && (
              <Alert variant="secondary" className="mt-3" style={{ borderRadius: 12, border: 'none', backgroundColor: '#f9fafb', color: '#6b7280', fontSize: '0.88rem', textAlign: 'center' }}>
                {successMessage}
              </Alert>
            )}
            {noTokenMessage && (
              <Alert variant="secondary" className="mt-3" style={{ borderRadius: 12, border: 'none', backgroundColor: '#f9fafb', color: '#6b7280', fontSize: '0.88rem', textAlign: 'center' }}>
                {noTokenMessage}
              </Alert>
            )}
          </Form>
        </div>
      </Container>
    </div>
  );
}

export default Unsubscribe;